<button mat-raised-button color="primary" *appRole="['Personas.Crear']" class="btn-nuevo" [routerLink]="['/personas','nuevo']">
    <mat-icon>add</mat-icon>
    Nueva persona
</button>
